import React from 'react';

const HeaderSignup = () => {
    return (
        <>
            <div className=' mx-auto sm:max-w-xl md:max-w-full mb-20 mx-auto'>
                <div className='p-8 rounded sm:p-8 bg-celeste_rancagua mx-auto'>
                    <div className=''>
                        <div className='grid grid-cols-1 lg:grid-cols-1'>
                            <img src='/assets/universidad_de_verano_1.png' alt='' className='mx-auto scale-75'/>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default HeaderSignup;